import React, { useState } from 'react';
import numeral from 'numeral';

import SinglePacking from './SinglePacking';

export const getPackingsLengthString = (count) => {
  let resultStr = count + ' ';
  const strLength = String(count).length;
  if ([11, 12, 13, 14].indexOf(Number(count)) !== -1) {
    resultStr += 'мест';
  } else {
    const symbol = strLength > 1 ? String(count)[strLength - 1] : count;
    switch (Number(symbol)) {
      case 1:
        resultStr += 'место';
        break;
      case 2:
      case 3:
      case 4:
        resultStr += 'места';
        break;
      default:
        resultStr += 'мест';
    }
  }
  return resultStr;
};

const Packings = (props) => {
  const { currentOrder, requirements, actualizeOrder } = props;
  const { packings } = currentOrder;

  const [opened, setOpened] = useState([]);
  const [tip, setTip] = useState([]);

  const handleTogglePacking = (i) => {
    const newArr = opened.slice();
    const currentIndex = opened.indexOf(i);
    if (currentIndex === -1) {
      newArr.push(i);
    } else {
      newArr.splice(currentIndex, 1);
    }
    setOpened(newArr);
  };

  const getPackingsWeight = (packings) => {
    const packWeight = packings.reduce((acc, p) => {
      return acc + p.measurements.weight / 1000;
    }, 0);
    return numeral(packWeight).format('0.[00]');
  };

  const getPackingsDimensions = (packings) => {
    const packDimensions =
      packings.reduce((acc, p) => {
        const dimensions = Object.values(p.measurements.dimensions).reduce((acc, d) => {
          return acc ? acc * d : d;
        }, null);
        return acc + dimensions;
      }, 0) / 1000000000;

    return packDimensions < 0.001
      ? 0.001
      : packDimensions < 0.01
      ? numeral(packDimensions).format('0.[000]')
      : numeral(packDimensions).format('0.[00]');
  };

  return (
    <>
      <div className="block-subtitle">Упакованные места</div>
      <div style={{ marginBottom: '8px', marginTop: '2px' }}>
        {getPackingsLengthString(packings.length)}
        {packings.length > 1 ? (
          <span>
            {' '}
            | {getPackingsWeight(packings)} кг | {getPackingsDimensions(packings)} кб.м
          </span>
        ) : null}
      </div>

      <div className="packings-wrapper card-content">
        {packings
          .sort((a, b) => a.num - b.num)
          .map((p, i) => (
            <SinglePacking
              key={`${p.barcode}-${i}`}
              {...p}
              data={p}
              currentOrder={currentOrder}
              isOpen={opened.indexOf(i) !== -1}
              requirements={requirements}
              tip={tip}
              setTip={setTip}
              actualizeOrder={actualizeOrder}
              onTogglePacking={() => handleTogglePacking(i)}
            />
          ))}
      </div>
    </>
  );
};

export default Packings;
